import React, { useState } from 'react';
import { Card, CardBody, CardFooter, Col } from 'reactstrap';
import {
  getLocalizedName,
  trimText,
} from '../../../../utility/util/util.service';
import LazyImage from '../../lazyload/lazy-image/lazy-image.component';
import * as Icon from 'react-feather';
import RemoveConfirmationModal from '../../modals/remove-confirmation/remove-confirmation.modal';
import { connect } from 'react-redux';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { deleteCategory } from './category-card.service';
import { history } from '../../../../history';
import SkeletonLoader from '../../lazyload/skeleton-loader/skeleton-loader.component';
import {
  fetchItemCategories,
  fetchMenuEntries,
} from '../../../../redux/store/store.actions';
import {
  setEditCategoryBulkModalData,
  setEditCategoryModalData,
  setEditMenuEntryCategoryModalData,
  setIsEditCategoryBulkModalOpen,
  setIsEditCategoryModalOpen,
  setIsEditMenuEntryCategoryModalOpen,
} from '../../../../redux/modal/modal.actions';
import { useIntl } from 'react-intl';
import DisplayTypeField from '../../form/fields/DisplayTypeField';
import { useLocation } from 'react-router-dom';

const CategoryCard = ({
  menuEntry,
  onClick,
  slug,
  isAdminMode,

  store,

  fetchMenuEntries,
  setIsEditCategoryModalOpen,
  setEditCategoryModalData,
  setIsEditMenuEntryCategoryModalOpen,
  setEditMenuEntryCategoryModalData,
  fetchItemCategories,
  setEditCategoryBulkModalData,
  setIsEditCategoryBulkModalOpen,
}) => {
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
  const intl = useIntl();
  const { search } = useLocation();

  const category = menuEntry?.categoryEntry;
  const categoryName = getLocalizedName(category, intl.locale);
  const coverImage = category?.coverImage;
  const displayImageOnly = menuEntry?.displayType === 'image_only';
  const displayTextOnly = menuEntry?.displayType === 'text_only';
  const displayFull = menuEntry?.displayType === 'full';
  const displayImage = displayFull || displayImageOnly;
  const displayText = displayFull || displayTextOnly;
  const categoryImageVisible = !!(coverImage && displayImage);
  const categoryNameVisible = !!(categoryName && displayText);
  const categoryImageClassNames = classnames('h-100 mh-10 img-cover-center', {
    'card-img': !isAdminMode && (displayImageOnly || !categoryNameVisible),
    'card-img-top':
      (!displayImageOnly && categoryNameVisible) ||
      (isAdminMode && (displayImageOnly || !categoryNameVisible)),
  });
  const categoryNameClassNames = classnames(
    'd-flex justify-content-center align-items-center text-center px-2 py-1',
  );
  const categoryNameSpanClassNames = classnames('font-medium-2 m-0', {
    'font-italic text-muted':
      !categoryNameVisible && isAdminMode && !categoryImageVisible,
  });
  const _onClick =
    onClick ||
    (() =>
      history.push(`/store/${slug}/${category?.id}${search || ''}`));
  const openEditModal = () => {
    setEditCategoryModalData({ category: category });
    setIsEditCategoryModalOpen(true);
  };
  const openEditCategoryModal = () => {
    setEditMenuEntryCategoryModalData({
      category: category,
    });
    setIsEditMenuEntryCategoryModalOpen(true);
  };
  const openCategoryBulkEdit = () => {
    setEditCategoryBulkModalData({
      category: category,
    });
    setIsEditCategoryBulkModalOpen(true);
  };
  return (
    <>
      <Col xl="4" lg="4" md="4" sm="6" xs="12" className="cursor-pointer">
        <Card data-testid="categoryCard">
          {category ? (
            categoryImageVisible && (
              <div className="d-flex flex-grow-1" onClick={_onClick}>
                <LazyImage
                  key={coverImage.id}
                  image={coverImage}
                  variant="menuEntry"
                  className={categoryImageClassNames}
                  placeholderContainerClassNames="h-100 mh-10 w-100 line-height-1 d-block"
                  placeholderClassNames="mh-10"
                />
              </div>
            )
          ) : (
            <SkeletonLoader
              height="100%"
              containerClassName="mh-10 card-img-top"
              style={{ top: '-3px' }}
            />
          )}
          {category ? (
            (categoryNameVisible || (isAdminMode && !categoryImageVisible)) && (
              <CardBody onClick={_onClick} className={categoryNameClassNames}>
                <h1
                  className={categoryNameSpanClassNames}
                  data-testid="categoryName"
                >
                  {trimText(categoryName, 30, ' ...')}
                </h1>
              </CardBody>
            )
          ) : (
            <CardBody className={categoryNameClassNames}>
              <span className={categoryNameSpanClassNames}>
                <SkeletonLoader width="60%" />
              </span>
            </CardBody>
          )}
          {category && isAdminMode && (
            <CardFooter className="bg-white p-1 d-flex justify-content-around align-items-center">
              <span onClick={() => setIsRemoveModalOpen(true)}>
                <Icon.Trash2
                  data-testid="removeItemButton"
                  size={22}
                  className="danger"
                />
              </span>
              <span onClick={openEditModal}>
                <Icon.Edit
                  data-testid="editCategoryButton"
                  size={22}
                  className="secondary"
                />
              </span>
              <span onClick={openEditCategoryModal}>
                <Icon.Folder
                  data-testid="moveToCategoryButton"
                  size={22}
                  className="secondary"
                />
              </span>
              <span onClick={openCategoryBulkEdit}>
                <Icon.ChevronsDown
                  data-testid="editBulkCategoryButton"
                  size={22}
                  className="secondary"
                />
              </span>
              <DisplayTypeField
                object={menuEntry}
                onSuccessCallback={() =>
                  fetchMenuEntries(store.menu.id, isAdminMode, undefined, store.id)
                }
              />
            </CardFooter>
          )}
        </Card>
      </Col>

      {category && isAdminMode && (
        <RemoveConfirmationModal
          isOpen={isRemoveModalOpen}
          closeModal={() => setIsRemoveModalOpen(false)}
          titleId="confirm"
          messageId="delete_confirmation_category"
          handleRemoval={() =>
            deleteCategory(category.id, store?.id, async () => {
              await fetchItemCategories(store.menu.id, isAdminMode, undefined, store.id);
              await fetchMenuEntries(store.menu.id, isAdminMode, undefined, store.id);
            })
          }
        />
      )}
    </>
  );
};

CategoryCard.propTypes = {
  menuEntry: PropTypes.object,
  slug: PropTypes.string,
  onClick: PropTypes.func,
  isAdminMode: PropTypes.bool,
  store: PropTypes.object,
  fetchMenuEntries: PropTypes.func,
  setIsEditCategoryModalOpen: PropTypes.func,
  setEditCategoryModalData: PropTypes.func,
};

const mapStateToProps = (state) => ({
  store: state.store.store,
});

export default connect(mapStateToProps, {
  fetchMenuEntries,
  setIsEditCategoryModalOpen,
  setEditCategoryModalData,
  setIsEditMenuEntryCategoryModalOpen,
  setEditMenuEntryCategoryModalData,
  fetchItemCategories,
  setEditCategoryBulkModalData,
  setIsEditCategoryBulkModalOpen,
})(CategoryCard);
